/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from './defs.defs.js'

const $nsid = 'app.bsky.actor.getProfiles'

export { $nsid }

/** Get detailed profile views of multiple actors. */
const main = l.query(
  $nsid,
  l.params({
    actors: l.array(l.string({ format: 'at-identifier' }), { maxLength: 25 }),
  }),
  l.jsonPayload({
    profiles: l.array(
      l.ref<ActorDefs.ProfileViewDetailed>(
        (() => ActorDefs.profileViewDetailed) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
